// extracted by mini-css-extract-plugin
export default {"button":"lm-z","reviewSort":"mm-z"};